import './index.less';
import React, { Component } from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import { LcStorage } from '../../util/storage';
import RangeManage from './cursor';
import TextareaCopyer from './copy';
import Suggester from './suggest';
import {
    escapeValue, mergeList, getStyle, getOffset, getIEVersion
} from './util';
import Request from '../../util/fetch';
/*
    点击@，文本框获得焦点且value增加一个@字符，同时计算文本框中@的位置，传递给suggest方便搜索列表框定位;
    如果@后存在字符且在20位内，则该字符为搜索的keyword;
    @后如果没有空格时选择搜索框中文本，此时光标需要从@处开始
*/
class At extends Component {
    constructor(props) {
        super(props);
        this.state = {
            textarea: null,
            atIndex: 0, // 给copy Com使用
            followData: undefined,
            show: false
        };
        // this.originFollow = ;
        this.SuggestShow = false; // 是否需要显示联想框
        this.textIndex = 0; // 当前联想框赋值使用
        this.clkAt = this.clkAt.bind(this);
        this.clkSuggest = this.clkSuggest.bind(this);
        this.fetchOffset = this.fetchOffset.bind(this);
        this.getPosition = this.getPosition.bind(this);
        this.hideSuggest = this.hideSuggest.bind(this);
        this.disposeSuggest = this.disposeSuggest.bind(this);
        this.request = this.request.bind(this);
        this.firstRequest = true;
    }

    request(userId) {
        const self = this;
        userId = userId || this.props.userId;
        if (!this.firstRequest) {
            return;
        }
        if (!userId) {
            return;
        }
        if (this.requesting) {
            return;
        }
        this.requesting = true;
        Request.fetch({
            url: `api/user/getfollows/${userId}`,
            data: {
                offset: 0,
                limit: 1000,
                order: true
            }
        })
            .then((data) => {
            // console.log(data);
                delete self.firstRequest;
                delete self.requesting;
                self.setState({
                    followData: data.follow
                });
                self.originFollow = data.follow;
            })
            .catch((err) => {
                console.log(err);
                delete self.requesting;
            });
    }

    fetchOffset(offset) {
        // console.log(offset);
        const self = this;
        const rootEleOffset = this.rootEleOffset;
        const newOffset = {
            x: offset.x - rootEleOffset.x,
            y: offset.y - rootEleOffset.y
        };
        self.setState({
            offset: newOffset
        });
        if (this.SuggestShow) {
            delete this.SuggestShow;
            self.setState({
                show: true
            });
        }
    }

    clkAt(e) {
        const { textarea } = this.state;
        const { saveValue, rangeData } = this.props;
        const textIndex = this.textIndex;
        textarea.focus();
        saveValue('@');
        // console.log('==click at==', textIndex, JSON.stringify(rangeData));

        // if(rangeData.start == textIndex){
        this.setState({
            show: true,
            followData: this.originFollow
        });
        // }
        // else{
        //     //delete self.initFirst;
        //     this.setState({
        //         atIndex : rangeData.start
        //     });
        // }
    }

    getMentioners() {
        let { userId } = this.props;
        userId = userId || 0;
        let list = LcStorage.getItem(`mentioners${userId}`);
        if (list) {
            list = JSON.parse(list);
        } else {
            list = [];
        }
        return list;
    }

    getSuggestData() {
        const { textarea } = this.state;
        const { rangeData } = this.props;
        const textIndex = this.textIndex;
        let followData = this.originFollow;
        const cursorPosition = rangeData.start;
        const atPosition = textIndex + 1;
        const mentioned = this.getMentioners();
        const mentionedObjs = [];
        let query = textarea.value.substring(atPosition, cursorPosition).toLowerCase();
        query = query.replace(/\[/g, '\\[');
        query = query.replace(/\]/g, '\\]');
        // console.log('===query===',query,atPosition, cursorPosition);
        // 找出2组数据重复的数据
        for (let i = 0, leni = mentioned.length; i < leni; i++) {
            for (let j = 0, lenj = followData.length; j < lenj; j++) {
                if (followData[j].nickname == mentioned[i]) { mentionedObjs.push(followData[j]); }
            }
        }

        followData = mergeList(followData, mentionedObjs);
        const follows = [];
        let qResult1;
        let qResult2;
        // 如果没有关注的人返回一个空数组
        if (followData.length > 0) {
            for (let i = 0, aLength = followData.length; i < aLength; i++) {
                qResult1 = followData[i].nickname.toLowerCase().search(query);
                qResult2 = followData[i].py ? followData[i].py.toLowerCase().search(query) : -1;
                if (qResult1 !== -1 || qResult2 != -1) {
                    follows.push(followData[i]);
                }
                if (follows.length === 10) {
                    break;
                }
            }
        }
        this.setState({
            followData: follows
        });
    }

    // 修改atIndex且不触发suggest
    setAtindex(atIndex) {
        // this.initFirst = true;
        this.setState({
            atIndex
        });
    }

    // 获取@列表的坐标
    getPosition(e) {
        // e.stopPropagation();
        const { textarea } = this.state;
        const { rangeData } = this.props;
        const value = textarea.value; // 文本框内容
        const length = value.length; // 内容长度
        const index = rangeData.start; // 光标位置
        let atIndex = 0; // @位置
        const keyCode = e.keyCode || e.which;
        let temp;

        let findAt = false; // 光标位置前20个字符中是否有@
        for (let i = 1; i < 20; i++) {
            temp = index - i;
            if (temp < 0) {
                temp = 0;
            }
            if (value.charAt(temp) === ' ') {
                break;
            }
            if (value.charAt(temp) === '@') {
                findAt = true;
                atIndex = temp;
                break;
            }
            if (temp == 0) {
                break;
            }
        }
        // if(atIndex > 0){
        //     this.setAtindex(atIndex);
        // }
        this.findAt = findAt;
        this.textIndex = atIndex;
        // console.log('==get position==', atIndex, findAt);
        // console.log('==keycode==', keyCode)
        if (findAt && e.shiftKey === false && keyCode !== 38 && keyCode !== 40) {
            if (keyCode !== 27 && keyCode !== 13) {
                // 增加搜索框
                this.setState({
                    show: true
                });
                this.getSuggestData();
            }
        } else if (keyCode !== 38 && keyCode !== 40) {
            // 隐藏搜索框
            this.hideSuggest();
        }
    }

    hideSuggest() {
        this.setState({
            show: false
        });
    }

    // 点击@列表项
    clkSuggest(value) {
        const { saveValue, rangeData } = this.props;
        const { atIndex, textarea } = this.state;
        const textIndex = this.textIndex;
        this.hideSuggest();
        value += ' ';
        // console.log('==click suggest1==', JSON.stringify(rangeData), textIndex);
        rangeData.start = this.findAt ? (textIndex + 1) : (atIndex + 1);
        // 如果是低版本的IE 添加@用户时候需要特殊处理
        if (getIEVersion && getIEVersion < 9) {
            textarea.value = textarea.value.substring(0, rangeData.start) + textarea.value.substring(rangeData.end, textarea.value.length);
            rangeData.end = rangeData.start;
        }
        // console.log('==click suggest2==', JSON.stringify(rangeData), value);
        saveValue(value, rangeData);
    }

    disposeSuggest(e) {
        const target = e.target;
        const { textarea } = this.state;
        if (target == textarea) {
            return;
        }
        const sugEle = this.sugEle;
        if (sugEle) {
            const sugRoot = sugEle.getRootDom();
            if (sugRoot.contains(target)) {
                return;
            }
        }
        this.hideSuggest();
    }

    componentWillReceiveProps(nextProps) {
        const { rangeData } = nextProps;
        this.setState({
            atIndex: rangeData.start
        });
        this.request(nextProps.userId);
    }

    componentDidMount() {
        const { getRichElement, saveValue } = this.props;
        const textarea = getRichElement();
        this.setState({
            textarea
        });
        textarea.addEventListener('keyup', this.getPosition, false);
        textarea.addEventListener('click', this.getPosition, false);
        // textarea.addEventListener('blur', this.hideSuggest, false);
        const rootEle = ReactDom.findDOMNode(this);
        this.rootEleOffset = getOffset(rootEle);
        this.rootEleOffset.w = rootEle.offsetWidth;
        this.rootEleOffset.h = rootEle.offsetHeight;
        // 全局添加隐藏@搜索框
        document.body.addEventListener('click', this.disposeSuggest, false);
        this.request();
    }

    componentWillUnmount() {
        const { textarea } = this.state;
        if (textarea) {
            textarea.removeEventListener('keyup', this.getPosition, false);
            textarea.removeEventListener('click', this.getPosition, false);
            document.body.removeEventListener('click', this.disposeSuggest, false);
        }
    }

    render() {
        const {
            textarea, atIndex, show, followData, offset
        } = this.state;
        const { className, getRichElement } = this.props;
        let cls = 'u-at';
        if (className) {
            cls += ` ${className}`;
        }
        let suggestNode;
        // console.log('===render===', show, atIndex);
        if (show) {
            suggestNode = (<Suggester ref={(ref) => { this.sugEle = ref; }} offset={offset} onClick={this.clkSuggest} list={followData} />);
        }
        return (
            <span className={cls} onClick={this.clkAt}>
                <TextareaCopyer onChangeOffset={this.fetchOffset} index={atIndex} textarea={textarea} />
                {suggestNode}
            </span>
        );
    }
}
At.propTypes = {
    className: PropTypes.string,
    saveValue: PropTypes.func,
    getRichElement: PropTypes.func,
    rangeData: PropTypes.object
};
export default At;



// WEBPACK FOOTER //
// ./client/component/at/index.js